<template>
  <form @submit.prevent="handleSubmit">
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Bank Transfer" disabled placeholder="Bank Transfer" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Withdraw From</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"
                    :rules="[(v) => !!v || 'Account is required']" :error="errors.account"
                    :error-messages="errors.account ? ['Account is required'] : []">
                  </v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-select v-model="selectedBank" :items="banks" item-text="bank_name" item-value="id" solo
                    append-icon="mdi-chevron-down" label="Select One" class="custom-select" hide-details
                    @change="handleBankChange" :rules="[(v) => !!v || 'Bank is required']" :error="errors.bank"
                    :error-messages="errors.bank ? ['Bank is required'] : []">
                  </v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Account No.</legend>
                  <v-text-field v-model="bankAccountNumber" label="Bank Account Number" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Account Name</legend>
                  <v-text-field v-model="bankAccountName" label="Bank Account Name" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field v-model="bankSwiftNum" label="" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Country</legend>
                  <v-text-field v-model="bankCountry" label="" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank City</legend>
                  <v-text-field v-model="bankCity" label="" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Bank Address</legend>
                  <v-text-field v-model="bankAddress" label="Write Here" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount <span v-if="withdrawAmount">(₹ {{ withdrawAmount * inrrate }})</span></legend>
                  <v-text-field v-model="withdrawAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select" min="1" :rules="amountRules" :error="errors.amount"
                    :error-messages="errors.amount ? ['Amount is required'] : []"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line
                    solo hide-details class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                 <small><v-icon size="17" class="mr-2" color="#039de9">mdi-information-outline</v-icon>OTP Will Send To Your <span v-if="otp_via == 1">Email Address. <small>(In case of failure check Phone no also.)</small></span> <span v-if="otp_via == 2">Phone Number. <small>(In case of failure check Email also.)</small></span> <span v-if="otp_via == 3">Phone Number and Email Address both.</span> </small>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn tile elevation="0" :loading="loading" :disabled="!isFormValid || loading"
                  class="ma-0 text-capitalize btn-account d-block" color="greenMain" type="submit">
                  Withdraw
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 rounded-0 deposit-form-card mt-2"
            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon color="greenMain">mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }}</span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>

            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { WITHDRAWMETHODS__ACTIONS } from "@/store/action-types";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      payment_id: null,
      selectedAccount: null,
      selectedBank: null,
      bankAccountNumber: '',
      bankAccountName: '',
      bankSwiftNum: '',
      bankCountry: '',
      bankCity: '',
      bankAddress: '',
      withdrawAmount: '',
      currencyAmount: '',
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#fff"
      },
      loading: false,
      errors: {
        account: false,
        bank: false,
        amount: false
      },
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
      amountRules: [
        v => !!v || 'Amount is required',
        v => v > 0 || 'Amount must be greater than 0',
        v => !this.selectedAccountDetails || parseFloat(v) <= this.selectedAccountDetails.MarginFree || 'Amount exceeds available funds'
      ]
    };
  },

  computed: {
    ...mapState("withdraw", ["methods", "accounts", "banks", "otp_via"]),
    ...mapState("deposit", ["inrrate"]),

    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account
      }));
    },
    selectedAccountDetails() {
      return this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
    },
    isFormValid() {
      return this.selectedAccount &&
        this.selectedBank &&
        this.withdrawAmount &&
        parseFloat(this.withdrawAmount) > 0 &&
        (!this.selectedAccountDetails || this.currencyAmount <= this.selectedAccountDetails.MarginFree);
    }
  },

  watch: {
    withdrawAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS,
      WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS,
      WITHDRAWMETHODS__ACTIONS.BROKERSBANK,
      WITHDRAWMETHODS__ACTIONS.CREATEBANKWITHDRAW,
      WITHDRAWMETHODS__ACTIONS.WITHDRAWOTP,
      WITHDRAWMETHODS__ACTIONS.OTPVIA,
    ]),
    ...mapActions("deposit", [DEPOSITMETHODS__ACTIONS.INRRATE]),


    handleAccountChange() {
      this.withdrawAmount = '';
      this.errors.account = false;
      this.currencyAmount = '';
      let account_details = this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    handleBankChange() {
      const selectedBank = this.banks.find(b => b.id === this.selectedBank);
      if (selectedBank) {
        this.bankAccountNumber = selectedBank.bank_acc_num;
        this.bankAccountName = selectedBank.bank_acc_name;
        this.bankSwiftNum = selectedBank.bank_swift_num;
        this.bankCountry = selectedBank.bank_country;
        this.bankCity = selectedBank.city_country;
        this.bankAddress = selectedBank.bank_address;
      }
      this.errors.bank = false;
    },

    validateForm() {
      this.errors.account = !this.selectedAccount;
      this.errors.bank = !this.selectedBank;
      this.errors.amount = !this.withdrawAmount || parseFloat(this.withdrawAmount) <= 0;

      return !this.errors.account && !this.errors.bank && !this.errors.amount;
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        toast.error('Please fill all required fields correctly');
        return;
      }

      this.loading = true;
      try {
        await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWOTP]()
        this.$router.push(`/bank-withdraw-otp?payment_id=${this.payment_id}&trading_account_no=${this.selectedAccount}&amount=${this.withdrawAmount}&bankId=${this.selectedBank}`)
        this.resetForm();
      } catch (error) {
        toast.error(error.message || 'Failed to process withdrawal');
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.selectedAccount = null;
      this.selectedBank = null;
      this.bankAccountNumber = '';
      this.bankAccountName = '';
      this.bankSwiftNum = '';
      this.bankCountry = '';
      this.bankCity = '';
      this.bankAddress = '';
      this.withdrawAmount = '';
      this.errors = {
        account: false,
        bank: false,
        amount: false
      };
    }
  },
  async mounted() {
    this.payment_id = this.$route.query.payment_id;
    await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS]();
    await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS]();
    await this[WITHDRAWMETHODS__ACTIONS.BROKERSBANK]();
    await this[DEPOSITMETHODS__ACTIONS.INRRATE]();
    await this[WITHDRAWMETHODS__ACTIONS.OTPVIA]();
  },
};
</script>